import { render, staticRenderFns } from "./MainLinksList.vue?vue&type=template&id=4e8724b1&"
import script from "./MainLinksList.vue?vue&type=script&lang=js&"
export * from "./MainLinksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports